import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import { Header } from '../Header';
import { Footer } from '../Footer';
import AsyncSelect from 'react-select/async';

export default class Operation extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: props.Id,
            data: null,
            loading: true,
            redirect: null,
        };
    }

    componentDidMount() {
        this.httpPost("api/v1/operation/get", {
            id: this.getCurrentFormId(),
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    });
                } else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }

    save(e) {
        e.preventDefault();

        this.httpPost("api/v1/operation/save", {
            id: this.getCurrentFormId(),
            companyId: this.state.data.record.companyId,
            name: this.state.data.record.name,
            accountId: this.state.data.record.accountId,
            transactionType: this.state.data.record.transactionType,
        })
            .then(data => {
                if (data.status === -1) {
                    window.location.href = "/login";
                } else if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                    this.setState({
                        redirect: '/operations'
                    });
                } else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }

    loadAccountOptions = (inputValue, callback) => {
        const companyId = this.state.data.global.company.id;
        setTimeout(() => {
            fetch("/api/v1/common/getaccounts/", {
                method: "post",
                body: JSON.stringify({
                    "term": inputValue,
                    "type": 3, // نوع حساب معین 
                    "parentCode": 0,
                    companyId,
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    let items = [];
                    if (response.status == 1) {
                        items = response.records.map(_record => ({
                            value: _record.fullCode,
                            label: (
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <span style={{ fontWeight: 'bold', margin: '0 5px', lineHeight: '30px' }}>{_record.fullCode}</span>
                                    <i className="bi bi-caret-left me-2"></i>
                                    <span>{_record.title}</span>
                                </div>
                            ),
                            id: _record.id // افزودن شناسه حساب
                        }));
                    }
                    callback(items); // فراخوانی callback با داده‌ها
                });
        }, 50);
    }

    setType(type) {
        this.state.data.record.transactionType = type;
        this.setState({ data: this.state.data });
    }

    handleSelectChange = (selectedOption) => {
        this.state.data.record.accountId = selectedOption.id; // تنظیم accountId
        this.setState({ data: this.state.data });
    }


    renderForm() {
        return (
            <div className="nk-content">
                <div className="container-fluid">
                    <div className="nk-content-inner">
                        <div className="nk-content-body">
                            <div className="components-preview wide-md mx-auto">
                                <div className="nk-block-head nk-block-head-lg wide-sm">
                                    <div className="nk-block-head-content">
                                        <div className="nk-block-head-sub">
                                            <a className="back-to" to="/operations/">
                                                <em className="icon ni ni-arrow-left" />
                                                <span>فهرست عملیات‌ها</span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div className="nk-block nk-block-lg">
                                    <div className="card card-bordered">
                                        <div className="card-inner">
                                            <div className="card-head">
                                                <h5 className="card-title">اطلاعات عملیات</h5>
                                            </div>
                                            <form method="post" onSubmit={e => this.save(e)} className="row g-4">
                                                <div className="col-lg-4">
                                                    <div className="form-group">
                                                        <label className="form-label">نوع تراکنش</label>
                                                        <div className="form-control-wrap">
                                                            <select className="form-control" defaultValue={this.state.data.record.transactionType} onChange={e => this.setType(parseInt(e.target.value))}>
                                                                <option value={0}>دریافت</option>
                                                                <option value={1}>پرداخت</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-4">
                                                    <div className="form-group">
                                                        <label className="form-label">نام عملیات</label>
                                                        <div className="form-control-wrap">
                                                            <input
                                                                className="form-control"
                                                                type="text"
                                                                defaultValue={this.state.data.record.name}
                                                                onChange={e => {
                                                                    this.state.data.record.name = e.target.value;
                                                                    this.setState({ data: this.state.data });
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-4">
                                                    <div className="form-group">
                                                        <label className="form-label">شناسه حساب</label>
                                                        <div className="form-control-wrap">
                                                            <AsyncSelect
                                                                cacheOptions
                                                                loadOptions={this.loadAccountOptions}
                                                                defaultValue={!this.isNull(this.state.data.record.fullCode) ? {
                                                                    value: this.state.data.record.fullCode,
                                                                    label: (
                                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                            <span style={{ fontWeight: 'bold', margin: '0 5px', lineHeight: '30px' }}>{this.state.data.record.fullCode}</span>
                                                                            <i className="bi bi-caret-left me-2" />
                                                                            <span>{this.state.data.record.title}</span>
                                                                        </div>
                                                                    )
                                                                } : null}
                                                                defaultOptions
                                                                onInputChange={this.handleInputChange}
                                                                onChange={this.handleSelectChange}
                                                                placeholder="جستجوی حساب معین"
                                                                styles={{
                                                                    control: (base) => ({
                                                                        ...base,
                                                                        minHeight: 30,
                                                                        height: 35,
                                                                        fontSize: 10,
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        width: '200px' // تنظیم عرض بزرگتر
                                                                    }),
                                                                    menu: (base) => ({
                                                                        ...base,
                                                                        fontSize: 10
                                                                    }),
                                                                    singleValue: (base) => ({
                                                                        ...base,
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        whiteSpace: 'normal',
                                                                        textOverflow: 'initial'
                                                                    }),
                                                                    indicatorSeparator: () => ({ display: 'none' }),
                                                                    dropdownIndicator: () => ({ display: 'none' })
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-12">
                                                    <div className="form-group">
                                                        <button type="submit" className="btn btn-lg btn-primary">ذخیره</button>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />
            ];

        return contents;
    }
}